/**
 * SVG-иконки интерфейса. Рисуются текущим цветом (currentColor), размер —
 * через width/height у корня; обводка единая, чтобы сетка читалась как набор.
 */

interface IconProps {
  size?: number
}

function base(size: number) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  } as const
}

export function IconSoundOn({ size = 22 }: IconProps) {
  return (
    <svg {...base(size)} aria-hidden="true" focusable="false">
      <path d="M11 5 6.5 9H3v6h3.5L11 19V5Z" fill="currentColor" stroke="none" />
      <path d="M15 9.5a4 4 0 0 1 0 5" />
      <path d="M17.5 7a7.5 7.5 0 0 1 0 10" />
    </svg>
  )
}

export function IconSoundOff({ size = 22 }: IconProps) {
  return (
    <svg {...base(size)} aria-hidden="true" focusable="false">
      <path d="M11 5 6.5 9H3v6h3.5L11 19V5Z" fill="currentColor" stroke="none" />
      <path d="m15.5 9.5 5 5" />
      <path d="m20.5 9.5-5 5" />
    </svg>
  )
}

export function IconTrophy({ size = 18 }: IconProps) {
  return (
    <svg {...base(size)} aria-hidden="true" focusable="false">
      <path d="M8 21h8" />
      <path d="M12 17v4" />
      <path d="M7 4h10v6a5 5 0 0 1-10 0V4Z" />
      <path d="M7 6H4.5a1 1 0 0 0-1 1c0 2 1.5 3.5 3.5 3.5" />
      <path d="M17 6h2.5a1 1 0 0 1 1 1c0 2-1.5 3.5-3.5 3.5" />
    </svg>
  )
}

export function IconWind({ size = 16 }: IconProps) {
  return (
    <svg {...base(size)} aria-hidden="true" focusable="false">
      <path d="M3 8h9a2.5 2.5 0 1 0-2.4-3.2" />
      <path d="M3 12h13a2.5 2.5 0 1 1-2.4 3.2" />
      <path d="M3 16h6" />
    </svg>
  )
}

export function IconWallet({ size = 18 }: IconProps) {
  return (
    <svg {...base(size)} aria-hidden="true" focusable="false">
      <path d="M3 7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v2" />
      <path d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4a2.5 2.5 0 0 0 0 5h4" />
      <circle cx="16" cy="13.5" r="0.6" fill="currentColor" stroke="none" />
    </svg>
  )
}

export function IconShield({ size = 18 }: IconProps) {
  return (
    <svg {...base(size)} aria-hidden="true" focusable="false">
      <path d="M12 3.5 5 6v5c0 5 3 8.2 7 9.5 4-1.3 7-4.5 7-9.5V6l-7-2.5Z" />
    </svg>
  )
}
